import ServiceLocator from "../../../services/ServiceLocator";
import { AsyncAction } from "../../types";
import { RefreshTokenIfNeeded } from "../../auth/actions";
import { HandleError } from '../../../stores/page/actions';
import { API_SERVER_ACTION_UPDATED, API_SERVER_ADDED, API_SERVER_DEPLOYED, API_SERVER_LOADED, API_SERVER_REMOVED, API_SERVERS_ACTION_UPDATED, API_SERVERS_CARD_LOADED, API_SERVERS_LOADED, ServerActionTypes } from "./types";
import { ServerData } from "../../../api/dtos/server/ServerResponse";
import { ServerActionRequest } from "../../../api/dtos/server/ServerActionRequest";
import { ServerCardData } from "../../../api/dtos/server/ServerCardResponse";

export function ApiGetServers(applicationId: number): AsyncAction {
    return RefreshTokenIfNeeded(async dispatch => {
        const response = await ServiceLocator.ServerService.GetServers(applicationId);
        if (response.is_success) {
            dispatch(ServersLoaded(response.data));
        } else {
            dispatch(HandleError(response));
        }
    });
}

export function ApiGetServer(applicationId: number, serverId: number): AsyncAction {
    return RefreshTokenIfNeeded(async dispatch => {
        const response = await ServiceLocator.ServerService.GetServer(applicationId, serverId);
        if (response.is_success) {
            dispatch(ServerLoaded(response.data));
        } else {
            dispatch(HandleError(response));
        }
    });
}

function ServersLoaded(servers: ServerData[]): ServerActionTypes {
    return {
        type: API_SERVERS_LOADED,
        servers
    };
}

function ServerLoaded(server: ServerData): ServerActionTypes {
    return {
        type: API_SERVER_LOADED,
        server
    };
}

export function ServerAdded(server: ServerData): ServerActionTypes {
    return {
        type: API_SERVER_ADDED,
        server
    };
}

export function ServerRemoved(serverId: number): ServerActionTypes {
    return {
        type: API_SERVER_REMOVED,
        serverId
    };
}

export function ServerDeployed(): ServerActionTypes {
    return {
        type: API_SERVER_DEPLOYED
    };
}

export function ServersActionUpdated(request: ServerActionRequest): ServerActionTypes {
    return {
        type: API_SERVERS_ACTION_UPDATED,
        isStarted: request
    };
}

export function ServerActionUpdated(serverId: number, request: ServerActionRequest): ServerActionTypes {
    return {
        type: API_SERVER_ACTION_UPDATED,
        serverId,
        isStarted: request
    };
}

//public
export function ApiGetServersCards(): AsyncAction {
    return async dispatch => {
        const response = await ServiceLocator.ServerService.GetServersCard();    
        if (response.is_success) {
            dispatch(ServersCardLoaded(response.data));
        } else {            
            dispatch(HandleError(response));
        }
    };
}

export function ServersCardLoaded(serversCards: ServerCardData[]): ServerActionTypes {
    return {
        type: API_SERVERS_CARD_LOADED,
        serversCards
    };
}